import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { AccordionComponent, AccordionPanelComponent } from "@kno2/shared/accordion";
import { AvatarComponent } from "@kno2/shared/avatar";
import { BadgeComponent } from "@kno2/shared/badge";
import { ButtonComponent } from "@kno2/shared/button";
import { ButtonGroupComponent } from "@kno2/shared/button-group";
import { CardComponent, Kno2CardHeader, Kno2CardTitle } from "@kno2/shared/card";
import { ChipComponent } from "@kno2/shared/chip";
import { DialogFooterDirective } from "@kno2/shared/dialog";
import {
    FormAutocompleteComponent,
    FormCheckboxComponent,
    FormDatepickerComponent,
    FormInputComponent,
    FormRadioInputComponent,
    FormSelectComponent,
    FormTagsSelectComponent,
    FormTextareaComponent
} from "@kno2/shared/forms";
import { InputGroupComponent } from "@kno2/shared/input-group";
import { MenuComponent } from "@kno2/shared/menu";
import { PaginatorComponent } from "@kno2/shared/paginator";
import { StepComponent, StepperComponent } from "@kno2/shared/stepper";
import { TabComponent, TabsComponent } from "@kno2/shared/tabs";
import { HeaderComponent } from "./components/header/header.component";
import { AppFrameLiteComponent } from "./layouts/app-frame-lite/app-frame-lite.layout";
import { CapitalizePipe } from "./pipes/capitalize.pipe";
import { FriendlyKeyNamePipe } from "./pipes/friendly-key-name.pipe";
import { NumberWithCommasPipe } from "./pipes/number-with-commas.pipe";
import { PluralPipe } from "./pipes/plural.pipe";
import { RoundPipe } from "./pipes/round.pipe";
import { TimingPipe } from "./pipes/timing.pipe";

const KNO2_COMPONENTS = [
    AvatarComponent,
    BadgeComponent,
    ButtonComponent,
    ButtonGroupComponent,
    CardComponent,
    Kno2CardHeader,
    Kno2CardTitle,
    InputGroupComponent,
    PaginatorComponent,
    TabsComponent,
    TabComponent,
    StepperComponent,
    StepComponent,
    AccordionComponent,
    AccordionPanelComponent,
    ChipComponent,
    DialogFooterDirective,
    MenuComponent,
    FormAutocompleteComponent,
    FormCheckboxComponent,
    FormDatepickerComponent,
    FormInputComponent,
    FormRadioInputComponent,
    FormSelectComponent,
    FormTagsSelectComponent,
    FormTextareaComponent
];
const COMPONENTS = [HeaderComponent, AppFrameLiteComponent];
const PIPES = [CapitalizePipe, FriendlyKeyNamePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe];

@NgModule({
    imports: [CommonModule, ...KNO2_COMPONENTS],
    exports: [CommonModule, ...KNO2_COMPONENTS, ...PIPES, ...COMPONENTS],
    declarations: [...COMPONENTS, ...PIPES]
})
export class SharedThemeModule {
    public static forRoot(): ModuleWithProviders<SharedThemeModule> {
        return {
            ngModule: SharedThemeModule,
            providers: []
        };
    }
}
